import { type GenericFieldHTMLAttributes } from 'formik'
import { type ButtonProps } from '../Button/Button.interface'
import { type RichTextProps } from '../RichText/RichText.interface'

export const FormKeys = {
  BUSINESS_NAME: 'businessName',
  WEBSITE_URL: 'websiteUrl',
  TELEPHONE_NUMBER: 'telephoneNumber',
  ADDRESS: 'address',
  SHORT_DESCRIPTION: 'shortDescription',
  LONG_DESCRIPTION: 'longDescription',
  IS_INDEPENDANT: 'isIndependant',
  BUSINESS_TYPE: 'businessType',
  CATEGORIES: 'categories',
  PRIMARY_IMAGE: 'primaryImage',
  SECONDARY_IMAGE: 'secondaryImage',
  THIRD_IMAGE: 'thirdImage',
  CONTACT_NAME: 'contactName',
  CONTACT_EMAIL: 'contactEmail',
  CAPTCHA: 'captchaToken',
  PLURALISED_CATEGORY_NAME: 'pluralisedCategoryName'
} as const

export interface Values {
  [FormKeys.BUSINESS_NAME]: string;
  [FormKeys.WEBSITE_URL]: string;
  [FormKeys.TELEPHONE_NUMBER]: string;
  [FormKeys.ADDRESS]: string;
  [FormKeys.SHORT_DESCRIPTION]: string;
  [FormKeys.LONG_DESCRIPTION]: string;
  [FormKeys.IS_INDEPENDANT]: string;
  [FormKeys.BUSINESS_TYPE]: string;
  [FormKeys.CATEGORIES]: string[];
  [FormKeys.PRIMARY_IMAGE]: string;
  [FormKeys.SECONDARY_IMAGE]: string;
  [FormKeys.THIRD_IMAGE]: string;
  [FormKeys.CONTACT_NAME]: string;
  [FormKeys.CONTACT_EMAIL]: string;
  [FormKeys.CAPTCHA]: string;
  [FormKeys.PLURALISED_CATEGORY_NAME]: string;
}

export interface CategoryOptions {
  id: string;
  label: string;
  value: string;
}
export interface CategoryProps {
  id: string;
  label: string;
  value: string;
  options: CategoryOptions[];
}

export interface SignUpFormProps {
  businessTitle: string;
  businessDescription: RichTextProps;
  categories: CategoryProps[];
  categoriesHeading: string;
  categoriesDescription: RichTextProps;
  photosHeading: string;
  photosDescription: RichTextProps;
  contactDetailsHeading: string;
  contactDetailsDescription: RichTextProps;
  submitButton: ButtonProps;
}

export interface FormProps {
  title: string;
  text: string;
}

export interface FieldBasics {
  className?: string;
  name: keyof Values;
  placeholder?: string;
  type?: string;
  label?: string;
  optionalText?: string;
  disableErrors?: boolean;
}

export type FieldProps = GenericFieldHTMLAttributes & FieldBasics & {
  type?: string;
  as?: never;
  rows?: never;
}

export type TextAreaProps = FieldBasics & {
  type?: never;
  as: 'textarea';
  rows: number;
}

export interface SelectOption {
  id: string;
  value: string;
  label: string;
  pluralisationText?: string;
}
